import type { ApiClientV2, ApiClientV2Default } from 'utils/api-client/api-client.utils'
import type { JSONAPIError, JSONResponse } from 'utils/api-client/types'
import type { InstallmentEligibilityAttributes, InstallmentEligibilityRequestAttributes } from 'types/__generated__/api'
import type { FromSwagger, FromSwaggerWithoutId } from 'types/helpers'

const BASE_URL = '/common/installment_eligibility'

export type InstallmentEligibilityParams = FromSwaggerWithoutId<InstallmentEligibilityRequestAttributes>
export type InstallmentEligibilityResult = FromSwagger<InstallmentEligibilityAttributes>
export type InstallmentEligibilityReason = NonNullable<InstallmentEligibilityResult['reason']>

export interface InstallmentEligibilityApi {
  check: (data: InstallmentEligibilityParams) => Promise<JSONResponse<InstallmentEligibilityResult> | JSONAPIError>
}

const TYPE = 'installment_eligibility'

export const createInstallmentEligibilityApi = ({
  POST,
}: Pick<ApiClientV2Default, 'POST'>): InstallmentEligibilityApi => ({
  check: (data) =>
    POST<InstallmentEligibilityResult>(BASE_URL, { data: { type: TYPE, attributes: data } }, undefined, true),
})

export const createShopInstallmentEligibilityApi = ({
  POST,
}: Pick<ApiClientV2, 'POST'>): InstallmentEligibilityApi => ({
  check: (data) => POST<InstallmentEligibilityResult>(BASE_URL, { type: TYPE, ...data }),
})
